import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './AdditionalIngredientsField.module.scss';

const AdditionalIngredientsField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="additionalIngredientsCountLabel"
				translationOptions={{ count: dishForFullInfo?.additionalDishes.length }}
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.additionalList}>
				{dishForFullInfo?.additionalDishes?.length
					? dishForFullInfo.additionalDishes.map((el) => {
							return (
								<div key={el.additionalId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.additionalName} size="s" withTooltip={true} />
									{el.externalId && (
										<ChunkOfTextWithCopying text={el.externalId} className={style.externalId} />
									)}
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default AdditionalIngredientsField;
